import {I18NString} from "./components/Utils";

export const Errors: {[key: string]: I18NString} = {
    "REQUIRED": {
        "ru": "Поле не заполнено"
    },
    "MAX_LENGTH": {
        "ru": "Максимальное кол-во символов"
    },
    "INVALID_FILE_FORMAT":{
        "ru": "Неверный формат файла: *."
    },
    "MAX_FILE_SIZE":{
        "ru": "Максимальный размер файла: "
    },
    "MIN_VALUE": {
        "ru": "Меньше минимального числа "
    },
    "MAX_VALUE": {
        "ru": "Больше максимального числа "
    },
};

export const Captions: {[key: string]: I18NString} = {
    "FILE": {
        "ru": "Выбрать файл"
    },
    "DELETE": {
        "ru": "Удалить"
    },
    "ADD": {
        "ru": "Добавить"
    },
    "SEND": {
        "ru": "Отправить на валидацию"
    }
};

export const Strings: {[key: string]: I18NString} = {
    "FILE_MAX_SIZE": {
        "ru": "Максимальный размер файла"
    },
    "CONFIRM_DELETE": {
        "ru": "Вы увурены что хотитие удалить?"
    },
    "EMPTY": {
        "ru": "Нет записей"
    }
};


// WEBPACK FOOTER //
// ./src/messages.tsx